var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAskConnector = function SvgAskConnector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    viewBox: "0 0 1008 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M517.208 54.5C517.208 61.2278 511.394 67 503.82 67C496.245 67 490.431 61.2278 490.431 54.5C490.431 47.7722 496.245 42 503.82 42C511.394 42 517.208 47.7722 517.208 54.5Z",
    stroke: "#D1D1D1",
    strokeWidth: 7,
    className: "circle"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3.5C7 1.567 5.433 0 3.5 0C1.567 0 0 1.567 0 3.5V38C0 48.7696 8.73045 57.5 19.5 57.5H487.228C487.033 56.5282 486.931 55.5254 486.931 54.5C486.931 53.1188 487.116 51.7785 487.463 50.5H19.5C12.5964 50.5 7 44.9036 7 38V3.5ZM520.176 50.5C520.523 51.7785 520.708 53.1188 520.708 54.5C520.708 55.5254 520.606 56.5282 520.412 57.5H987.611C994.515 57.5 1000.11 63.0964 1000.11 70V100.5C1000.11 102.433 1001.68 104 1003.61 104C1005.54 104 1007.11 102.433 1007.11 100.5V70C1007.11 59.2304 998.381 50.5 987.611 50.5H520.176Z",
    fill: "#D1D1D1",
    className: "line"
  })));
};
export default SvgAskConnector;